import { useHistory } from "react-router-dom";
import { Page } from "@common-ui/ui";
import { Auth } from "aws-amplify";
import { useEffect } from "react";

import { Header } from "../../components";
import { CreateAssetForm } from "./CreateAssetForm";

export const CreateAsset = () => {
  let history = useHistory();
  useEffect(() => {
    async function fetchData() {
      try {
        await Auth.currentAuthenticatedUser();
      } catch (error) {
        history && history.push("/sign-in");
      }
    }
    fetchData();
  }, [history]);

  return (
    <Page
      title="Create Asset"
      // style={{ backgroundColor: "#fff", minHeight: "calc(100vh - 52px)" }}
    >
      <Header xl name="Create Asset" history={history} />
      <CreateAssetForm />
    </Page>
  );
};
